<script setup>
import { computed, useAttrs } from 'vue'
import { useStore } from 'vuex'
import { AgGridVue } from 'ag-grid-vue3'
import { createAgGridLocaleText } from '@/utils/agGridLocale.mjs'

defineOptions({ inheritAttrs: false })

const attrs = useAttrs()
const store = useStore()
const localeText = computed(() => createAgGridLocaleText(store.state.basic.locale))
const defaultColDef = computed(() => ({
  tooltipValueGetter: (params) => params.valueFormatted ?? params.value ?? '',
  ...attrs.defaultColDef,
}))
const tooltipShowMode = computed(() => attrs.tooltipShowMode ?? 'whenTruncated')
const tooltipShowDelay = computed(() => attrs.tooltipShowDelay ?? 300)
</script>

<template>
  <AgGridVue
    v-bind="attrs"
    :default-col-def="defaultColDef"
    :locale-text="localeText"
    :tooltip-show-mode="tooltipShowMode"
    :tooltip-show-delay="tooltipShowDelay"
  />
</template>
